import React__default from 'react';
import { Util } from '@grandvisionhq/common';
import { replaceStoreFinderUrlWithNewQueryParams } from '../../../utils/store-utils.js';

const useStoreFinderUrlParams = ({ handleOnChange , setIsUserLocation , newQueryParams , enabled =false  })=>{
    const [initialSearchQuery, setInitialSearchQuery] = React__default.useState(undefined);
    React__default.useEffect(()=>{
        if (!enabled) {
            return;
        }
        const search = Util.getQueryParamByKey('search');
        const isUserLocation = Util.getQueryParamByKey('userLocation') === 'true';
        setIsUserLocation(isUserLocation);
        setInitialSearchQuery(search);
        if ((search === null || search === void 0 ? void 0 : search.length) && !isUserLocation) {
            handleOnChange(search);
        }
    }, [
        enabled
    ]);
    React__default.useEffect(()=>{
        if (enabled) {
            replaceStoreFinderUrlWithNewQueryParams(newQueryParams);
        }
    }, [
        enabled,
        newQueryParams
    ]);
    return initialSearchQuery;
};
var useStoreFinderUrlParams$1 = useStoreFinderUrlParams;

export { useStoreFinderUrlParams$1 as default };
//# sourceMappingURL=use-store-finder-url-params.js.map
